<template>
<v-content class="home">
  <v-carousel height="91vh" cycle interval="14000" hide-delimiter-background show-arrows-on-hover>
    <v-carousel-item>
      <v-img class="shinjuku-bg fill-height" src="@/assets/shinjuku.jpg" lazy-src="@/assets/shinjuku_lazy.jpg">
      </v-img>
      <v-row id="welcome" align="center" justify="center" class="fill-height">
        <v-col class="text-center" cols="8" sm="4">
          <v-card  class="pa-2" raised tile>
            <h1 class="text-uppercase font-weight-thin display-1">Welcome to my world</h1>
          </v-card>
          <v-card class="mt-2" raised tile>
            <h2 class="text-uppercase font-weight-thin subtitle-1">Browse to discover it</h2>
          </v-card>
        </v-col>
      </v-row>
    </v-carousel-item>
    <v-carousel-item>
      <v-row v-if="this.$vuetify.breakpoint.name === 'xs'" id="who-mobile" align="center" justify="center" class="fill-height">
        <v-col class="text-center" cols="9">
          <h1 class="display-1 font-weight-thin mb-4">Who am I?</h1>
          <p>French IT Engineer based in Tokyo, I am always looking for new challenges in my daily life where learning means growing as a person.</p>
          <p>Passionate, and especially when it comes to new technologies, I put in the foreground Respect and Integrity which are part of my core values.</p>
        </v-col>
      </v-row>
      <v-row v-else id="who" align="center" justify="center" class="fill-height">
        <v-col class="text-center" cols="4">
          <v-img src="@/assets/shadow.jpg" lazy-src="@/assets/shadow_lazy.jpg" aspect-ratio="1"><template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template></v-img>
        </v-col>
        <v-col class="text-center" cols="6">
          <h1 class="display-1 font-weight-thin mb-4">Who am I?</h1>
          <p>French IT Engineer based in Tokyo, I am always looking for new challenges in my daily life where learning means growing as a person.</p>
          <p>Passionate, and especially when it comes to new technologies, I put in the foreground Respect and Integrity which are part of my core values.</p>
        </v-col>
        <!-- <v-col class="text-center" cols="12" sm="4">
          <v-img src="@/assets/shadow.jpg" lazy-src="@/assets/shadow.jpg" aspect-ratio="1"></v-img>
        </v-col> -->

      </v-row>
    </v-carousel-item>

    <!-- to imrpove for more content with data -->
    <!-- <v-carousel-item v-for="(slide, i) in slides" :key="i">
      <v-sheet :color="colors[i]" height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <div class="display-3">{{ slide }} Slide</div>
        </v-row>
      </v-sheet>
    </v-carousel-item> -->
  </v-carousel>
</v-content>
</template>

<script>
export default {
  name: 'Home',
  // data() {
  //   return {
  //     colors: [
  //       'indigo',
  //       'warning',
  //       'pink darken-2',
  //       'red lighten-1',
  //       'deep-purple accent-4',
  //     ],
  //     slides: [
  //       'First',
  //       'Second',
  //       'Third',
  //       'Fourth',
  //       'Fifth',
  //     ],
  //   }
}
</script>
<style Scoped>
.shinjuku-bg {
  position: absolute;
  top: 0px;
}

/* #welcome {
  background-image: url("../assets/shinjuku.jpg");
  background-size: cover;
} */
</style>
